import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

import { SkeletonContentContainer } from './th-scan-and-pay.styled';

export const ScanAndPayContentSkeleton: React.FC = () => {
  return (
    <SkeletonContentContainer data-testid="scan-and-pay-content-skeleton">
      <Skeleton count={2} width={'100%'} />
    </SkeletonContentContainer>
  );
};
